export const SYSTEM_PATH = {
    TBD_SCREEN: '/tbd',
    SET_PASSWORD: '/student/set-password',
    FORGOT_PASSWORD: '/forgot-password',
    LOGIN: '/login',
    HOME: '/',
    HOME_PREVIEW: '/preview',
    // register
    REGISTRATION_FIRST_STEP: '/registration/first-step',
    REGISTRATION_SECOND_STEP: '/registration/second-step',
    REGISTRATION_THIRD_STEP: '/registration/third-step',
    // mypage
    PROFILE: '/profile',
    PROFILE_EDIT: '/profile-edit',
    CHANGE_PASSWORD: '/change-password',
    PURCHASE_HISTORY: '/purchase-history',
    TOOL_CERTIFICATE: '/tool-certificate',
    ACCOUNT_SETTING: '/account-setting',
    MAIL_SUBSCRIPTION: '/mail-subscription',
    // theme
    THEMES: '/course-list',
    THEME: '/theme/',
    // course
    COURSE_DETAIL: '/course/:id',
    COURSE: '/course/',
    // completion test
    COMPLETION_TEST: '/course/:courseId/completion-test',
    // lecture
    LECTURES: '/lectures',
    LECTURE: '/lecture/',
    LECTURE_DETAIL: '/lecture/:id',
    // message
    MESSAGES: '/messages',
    MESSAGE: '/message/',
    MESSAGE_DETAIL: '/message/:id',
    // ticket
    TICKETS: '/tickets',
    // payment
    PAYMENT: '/payment',
    PAYMENT_STATUS: '/student/payment/payment-status/:id',
    PAYMENT_FREE_STATUS: '/payment/payment-status/:id',
    // user guide
    USER_GUIDE: '/user-guide',
    // faq
    FAQ_SCREEN: '/faqs',
    // contact us
    SEND_INQUIRY: '/contact-us',
    // student group list
    STUDENT_GROUP_LIST: '/student-of-group',
    STUDENT_DETAIL: '/student-detail/:id',
    STUDENT_DETAIL_EI: '/student-detail-ei/:id',
    COURSE_LIST_BY_STUDENT: '/course-list-by-student/:id',
    STUDENT_LIST_BY_ATTENDANCE_CODE: '/student-list-by-attendance-code/:id',
    STUDENT_LIST_BY_ATTENDANCE_LIST_CODE: '/student-list-by-attendance-list-code/:id',
    PENDING_APPROVAL_BY_ATTENDANCE_CODE: '/pending-approval-by-attendance-code/:id',
    CONFIRMING_BY_ATTENDANCE_CODE: '/confirming-by-attendance-code/:id',
    // about us
    ABOUT_US: '/about-us',
    // attendance history
    ATTENDANCE_HISTORY: '/attendance-history',
    ATTENDANCE_HISTORY_EI: '/attendance-history-ei',
    TERM_OF_SERVICE: '/term-of-service',
    PRIVACY_POLICY: '/privacy-policy',
    CANCELLATION_POLICY: '/cancellation-policy',
    SPECIFIED_COMMERCIAL_TRANSACTION_LAW_DISPLAY: '/specified-commercial-transaction-law-display',
    RECOMMENDED_ENVIRONMENT: '/recommended-environment',
    ABOUT_COMPANY: '/about-elephamt',
    // credit
    CREDIT_HISTORY: '/credit-history',
    // notifications,
    NOTIFY_LIST: '/notification',
    NOTIFY_DETAIL: '/notification/:id',
    // confirm email
    CONFIRM_EMAIL: '/student/confirm-email',
    // test result history
    TEST_RESULT_HISTORY: '/test-result-history/:id',
    // survey
    SURVEY_SCREEN: '/survey/:courseId',

    // information
    INFORMATION_SCREEN: '/information',
    INFORMATION_DETAIL: '/information/:id',

    // training list
    TRAINING_LIST: '/training-list',
    COMPANY_TRAINING_LIST: '/company-training-list',
    COMPANY_TRAINING_COURSE_DETAIL: '/company-training-course/:id',
    COMPANY_TRAINING_COMPLETION_SETTINGS: '/company-training-ticket-plan/:ticketId/completion-settings',
    COMPANY_TRAINING_CERTIFICATE_DOWNLOAD: '/company-training-ticket-plan/:ticketId/certificate-download',
    SHARE_KNOWLEDGE: '/share-knowledge',
    SHARE_KNOWLEDGE_FILE_LIST: '/share-knowledge/file',
    SHARE_KNOWLEDGE_REQUEST_LIST: '/share-knowledge/request',
    SHARE_KNOWLEDGE_VIEWER_LIST: '/share-knowledge/viewer/:fileId',

    // first test of course
    FIRST_TEST_OF_COURSE: '/first-test-of-course/:id',

    SET_PASSWORD_SYNC: '/student/set-password-sync'
};

export const MSG = {
    //#region Api message
    'api.response.worng_format': '応答本文は正しい形式ではありません',
    'api.response.no_message': 'エラーメッセージの応答はありません',
    'api.response.server_error':
        'サーバ接続に問題が発生しました。お手数ですが、もう一度アクセスし直してください。',
    'api.response.no_network':
        'サーバ接続に問題が発生しました。お手数ですが、もう一度アクセスし直してください。',
    'api.response.authorization': '再度ログインして下さい。',
    //#endregion Api message

    //#region inform
    'inform.success.create': 'メッセージ送信を完了しました。',
    'inform.success.update': '編集は完了しました。',
    'inform.success.delete': '削除が完了しました。',
    'inform.success.import': '削除正常にインポート',
    'inform.success.update.profile': 'アカウント情報の変更が完了しました。',
    'inform.success.cancel.attendance': 'キャンセルは完了しました。',
    //#endregion

    //#region validate error message
    'error.required': '必須項目をご入力ください',
    'error.email_format': 'メールアドレスが正しくありません。',
    'error.email_confirm_not_match': '上記メールアドレスと一致しません。',
    'error.number_positive': '正数を入力してください。',
    'error.password_format': 'パスワードが正しくありません。',
    'error.confirm_password_not_match': '上記パスワードと一致しないため再入力をお願いします。',
    'error.promotion_code_not_match_format': '割引きクーポンコードが正しくありません。',
    'error.promotion_code_expires': '割引きクーポンコードの有効期限が切れています。',
    'error.password_format_detail': '８文字以上の半角英数字（１つ以上の大文字含める）',
    'error.employee_code_format': '社員番号は半角英数字で入力してください。',
    'error.format_latin_kanji': '漢字またはローマ字でご入力ください。',
    'error.format_hira_kata': 'フリガナでご入力ください。',
    'error.report.unsupported_format': 'ファイルの拡張子がサポートされていません。PDFのいずれかの拡張子で、ファイルをアップロードすることが可能。',
    'error.report.file_size': 'ファイルのアップロードに失敗しました。ファイルサイズが上限の100MBを超えています。再度お試しください。',
    'error.max_length': (length) => `${length}文字以内で入力してください。`,
    //#endregion
    // user
    'confirm.confirm_active_user_title': '確認',
    'confirm.confirm_active_user_content': 'ステータスは有効にしてもよろしいですか。',
    'confirm.confirm_deactive_user_title': '確認',
    'confirm.confirm_deactive_user_content': 'ステータスは無効にしてもよろしいですか。',
    'confirm.confirm_delete_user_title': '確認',
    'confirm.confirm_delete_user_content': '削除してもよろしいですか？削除すれば、それに紐づく全 てのデータも削除されます',
    // student
    'confirm.confirm_delete_student_title': '確認',
    'confirm.confirm_delete_student_content': '削除してもよろしいですか？削除すれば、それに紐づく全てのデータも削除されます。',
    'confirm.confirm_active_student_title': '確認',
    'confirm.confirm_active_student_content': '選択した受講者を有効にしてよろしいですか。',
    'confirm.confirm_deactive_student_title': '確認',
    'confirm.confirm_deactive_student_content': '選択した受講者を無効にしてよろしいですか。',
    'error.student_confirm_pharmacist_not_match_format': '上記「薬剤師名簿登録番号」 と一致しません。',
    'error.student_accept_file': 'システムは CSV ファイルインポートのみサポートする',
    'error.student_empty_csv_file': 'CSVファイルにある全ての項目は必須項目となります。',
    //#region promotion
    'confirm.confirm_delete_promotion_title': '確認',
    'confirm.confirm_delete_promotion_content': '削除すると、それに紐づく全てのデータも削除されます。',
    'confirm.confirm_active_promotion_title': '確認',
    'confirm.confirm_active_promotion_content': 'ステータスを「有効」にしてもよろしいですか？',
    'confirm.confirm_deactive_promotion_title': '確認',
    'confirm.confirm_deactive_promotion_content': 'ステータスを「無効」にしてもよろしいですか？',
    'error.max_length_amount': 'Number of characters longer than 9',
    //#endregion

    //#region faq
    'confirm.confirm_delete_faq_title': '確認',
    'confirm.confirm_delete_faq_content': '選択したよくある質問を削除してよろしいですか。',
    //#endregion


    //#region course
    'confirm.confirm_delete_course_title': '確認',
    'confirm.confirm_delete_course_content': '選択された講座は削除してもよろしいですか。',

    'confirm.confirm_active_course_title': '確認',
    'confirm.confirm_active_course_content': '選択された講座は有効にしてもよろしいですか。',
    'confirm.confirm_deactive_course_title': '確認',
    'confirm.confirm_deactive_course_content': '選択された講座は無効にしてもよろしいですか。',
    'error.view_old_course': 'この講座を視聴する前に、一つの受講プランを追加してください。',
    //#endregion

    // lecture
    'error.maximum_image_file': 'ファイルサイズの上限は10MBです。',
    'error.invalid_image': 'ファイルの拡張子がサポートされていません。JPG(JPEG)、PNG、GIFのいずれかの拡張子で、ファイルをアップロードすることが可能。',
    'error.confirm_cancel_create': 'Are you sure you want to quit? All progress in this session will be lost.',
    'error.invalid_video': 'ファイルの拡張子がサポートされていません。MP4の拡張子ファイルをアップロードする必要がございます。',
    'error.maximum_video_file': 'ファイル容量の上限は2.5 GBです。',
    'msg.upload_video_title': '動画アップロード中',
    'msg.upload_video_desc': 'アップロードが完了するまでブラウザは閉じないでください。',
    'confirm.delete_lecture': '削除してもよろしいですか？削除すると、それに紐づく全てのデータも削除されます。',
    'confirm.change_lecture_to_active': 'ステータスは有効にしてもよろしいですか。',
    'confirm.change_lecture_to_inactive': 'ステータスは無効にしてもよろしいですか。',
    'confirm.confirm_export_invoice_purchase_content': '領収書を出力したい対象を選択してください。',

    // message
    'msg.send_to_all': 'すべてのユーザーに送信',


    'warning.student.apply.ticket': 'この操作を実行する前に、システムにログインしてください。',
    'confirm.student.send.email': 'メールを送信しました。ご確認ください！',
    'warning.student.view.lecture.detail': '詳細表示にはログインしてください',
    'warning.student.apply.course.none.ticket': '購入した受講プラン分の講座受講は全て完了しました。受講するには新たに受講プランを購入してください。',
    'warning.student.applyed.course.of.ticket': (courseAttended) =>
        `${courseAttended}つの講座は既に受講完了されているため、この受講プランを購入すると${courseAttended}単位分 がプラン数から差し引かれます。このプランを購入しますか?`,

    // purchase
    'warning.student.delete_purchase': 'この購入取引を削除しますが、よろしいですか。',
    'warning.student.request_cancel_purchase': 'この購入取引をキャンセルリクエストしますが、よろしいですか。',

    // tool certificate
    'tool.certificate.update.success': 'データが更新されました。',

    // cancel attendance
    'cancel.attendance.update.confirm': '受講中講座の受講をキャンセルしてもよろしいですか。',
    'error.attending.course.with.cancel': '現在受講中の講座の受講を完了させてください。\n受講中講座のキャンセルは下記ボタンを押してください。',
    'error.attending.course.no.cancel': '現在受講中の講座の受講を完了させてください。',

    // training course
    'warning.student.delete_question': 'この質問を削除してよろしいですか。',
    'warning.student.add_question': 'この内容で送信しますか？',

    // course plan
    'warning.student.reset_course_plan': '受講計画をリセットしてもよろしいですか。',
    'warning.student.cancel_course_plan': '受講計画をリセットしてもよろしいですか。'
};

export const DEFAULT_PAGE_SIZE = 10;
export const PAGE_SIZE_OPTIONS = [10, 50, 100, 500, 1000, 2000];
// There are alot of table in system. Example: Document, Form difinition, User, Tenant.
export const TABLE_CODE = {
    DOCUMENT: 0
}

export const DATE_YMD = 'YYYY/MM/DD';
export const DATE_TIME_YMD = 'YYYY/MM/DD HH:mm';
export const DATE_TIME_FULL = 'YYYY/MM/DD HH:mm:ss';
export const DATE_YMD_ISO = 'YYYY-MM-DD';
export const DATE_TIME_YMD_ISO = 'YYYY-MM-DD HH:mm';
export const DATE_TIME_FULL_ISO = 'YYYY-MM-DD HH:mm:ss';
export const DATE_YMD_JP = 'YYYY年MM月DD日';
export const DATE_MD_JP = 'MM月DD日';

//#region const student
export const GENDER = {
    MALE: 0,
    FEMALE: 1
}

export const GENDER_STRING = {
    MALE: '男性',
    FEMALE: '女性'
}

export const GENDER_MAP = {
    0: GENDER_STRING.MALE,
    1: GENDER_STRING.FEMALE
}

// 1 offshore, 2 outside
export const OUTSIDE_OFFSHORE = {
    OTHER: 0,
    OFFSHORE: 1,
    OUTSIDE: 2
}

export const OUTSIDE_OFFSHORE_STRING = {
    OTHER: '選択なし',
    OFFSHORE: '沖',
    OUTSIDE: '外'
}

// 1 offshore, 2 outside
export const WORK_FORM = {
    OTHER: 0,
    OFFSHORE: 1,
    OUTSIDE: 2
}

export const WORK_FORM_STRING = {
    OTHER: '選択なし',
    OFFSHORE: '沖',
    OUTSIDE: '外'
}

export const WORK_FORM_MAP = {
    0: WORK_FORM_STRING.OTHER,
    1: WORK_FORM_STRING.OFFSHORE,
    2: WORK_FORM_STRING.OUTSIDE
}

export const WORK_TYPE = {
    // 保険薬局,
    USER_DISPENSING_PHARMACY: '保険薬局',
    // Dgs
    USER_DGS: 'Dgs',
    // 病院
    USER_HOSPITAL: '病院',
    // 製薬企業
    USER_PHARMACEUTICAL_COMPANIES: '製薬企業',
    // 卸
    USER_WHOLESALER: '卸',
    // その他
    USER_OTHERS: 'その他'
}
//#endregion

export const PREFECTURES = [
    '北海道',
    '青森県',
    '岩手県',
    '宮城県',
    '秋田県',
    '山形県',
    '福島県',
    '茨城県',
    '栃木県',
    '群馬県',
    '埼玉県',
    '千葉県',
    '東京都',
    '神奈川県',
    '新潟県',
    '富山県',
    '石川県',
    '福井県',
    '山梨県',
    '長野県',
    '岐阜県',
    '静岡県',
    '愛知県',
    '三重県',
    '滋賀県',
    '京都府',
    '大阪府',
    '兵庫県',
    '奈良県',
    '和歌山県',
    '鳥取県',
    '島根県',
    '岡山県',
    '広島県',
    '山口県',
    '徳島県',
    '香川県',
    '愛媛県',
    '高知県',
    '福岡県',
    '佐賀県',
    '長崎県',
    '熊本県',
    '大分県',
    '宮崎県',
    '鹿児島県',
    '沖縄県'
];

export const FAQ_CATEGORY = [
    '①お申込みについて',
    '➁お支払いについて',
    '③受講関連について',
    '④コンテンツ内容について',
    '⑤単位取得について',
    '⑥操作方法について',
    '⑦その他'
]

export const MAX_IMAGE_SIZE = 10; // Mb
export const MAX_VIDEO_SIZE = 2.5 * 1000; // Mb
export const SAMPLE_VIDEOS_CAROUSEL_INTERVAL = 24 * 60 * 60 * 1000;
export const IMAGE_SUPPORT_FILES = ['jpg', 'jpeg', 'png', 'gif'];
//#region const course
export const COURSE_TYPE = {
    TRAINING_CERTIFIED_PHARMACIST: 0,
    SOCIETY_ACCREDITED_CREDITS: 1,
    HERBAL_MEDICINE: 2,
    DRUG_THERAPY_CERTIFIED_PHARMACIST: 3,
    NON_CERTIFICATE: -1
}

export const COURSE_TYPE_STRING = {
    TRAINING_CERTIFIED_PHARMACIST: '研修認定薬剤師',
    SOCIETY_ACCREDITED_CREDITS: '精神薬学会認定薬剤師',
    HERBAL_MEDICINE: '漢方薬・生薬認定薬剤師',
    DRUG_THERAPY_CERTIFIED_PHARMACIST: '小児薬物療法認定薬剤師',
    NON_CERTIFICATE: '認定制度対象外'
}
//#endregion
export const PATTERN_STRING_ONLY = /^\d+\.?\d*$/;

export const WIDTH_COLUMN_SELECT_TABLE = '50px';


export const USER_TYPE = {
    STUDENT_INDIVIDUAL: 3,
    STUDENT_GROUP: 4,
    JIHOU_ADMINISTRATOR: 1,
    GROUP_MANAGER: 2
}

export const USER_TYPE_STRING = {
    STUDENT_INDIVIDUAL: '個人受講者',
    STUDENT_GROUP: '法人受講者',
    JIHOU_ADMINISTRATOR: 'じほう管理者',
    GROUP_MANAGER: '法人管理者'
}

export const messageCategories = [
    {
        id: 1,
        name: '重要なお知らせ'
    },
    {
        id: 2,
        name: '受講期間終了のお知らせ'
    },
    {
        id: 3,
        name: '新講座のご案内'
    },
    {
        id: 4,
        name: 'おすすめ講座のご案内'
    },
    {
        id: 5,
        name: '講座変更のお知らせ'
    },
    {
        id: 6,
        name: '講座配信停止のお知らせ'
    },
    {
        id: 7,
        name: '単位未申請のお知らせ'
    },
    {
        id: 8,
        name: 'システムメンテナンスのお知らせ'
    }
];
export const COURSE_STATUS = {
    ACTIVE: 1,
    INACTIVE: 0,
    VIDEO_PENDDING: 2
}

export const COURSE_STATUS_STRING = {
    ACTIVE: '有効',
    INACTIVE: '無効',
    VIDEO_PENDDING: 'ビデオ変換中'
}

export const COURSE_STATUS_COMPLETE = {
    USER_COURSE_NOT_ATTENDED: 0, // NOT ATTENDED
    USER_COURSE_ATTENDING: 1, // ATTENDING
    USER_COURSE_NOT_DO_TEST: 2, // TEST NOT TAKEN
    USER_COURSE_APPLY_CERTIFICATE: 3 // CERTIFICATE APPLIED
}

export const LECTURE_STATUS_OF_COURSE = {
    USER_LECTURE_NOT_ATTENDED: 0, // NOT ATTENDED
    USER_LECTURE_ATTENDING: 1, // ATTENDING
    USER_LECTURE_COMPLETE: 2 // COMPLETE
}

export const LECTURE_STATUS_OF_COURSE_MESSAGE = {
    USER_NOT_LOGIN: '詳細表示にはログインしてください',
    USER_LECTURE_NOT_ATTENDED: 'このコンテンツを視聴するためには「受講ボタン」を押してください。', // NOT ATTENDED
    USER_LECTURE_ATTENDING: '受講期間がまだ始まっておりません。受講期間をお確かめの上受講を開始してください。',
    USER_LECTURE_EXPIRED: '受講期限が切れました。このコンテンツを続けて視聴する為にチケットを購入してください。',
    COURSE_NOT_IN_TICKET_PLAN: '受講プランの該当講座しか受講できません。',
    NOT_ENOUGH_FREE_TICKET: '自由選択単位数の上限に達しているため、この講座を受講することはできません。'
}

export const PHARMACIST_CERTIFICATION = {
    TRAINING_CERTIFIED_PHARMACIST: 0,
    PSYCHIATRIC_SOCIETY_CERTIFIED_PHARMACIST: 1,
    CHINESE_HERBAL_MEDICINE_CRUDE_DRUG_CERTIFIED_PHARMACIST_FOR_RENEWAL_ONLY: 2,
    PEDIATRIC_DRUG_THERAPY_CERTIFIED_PHARMACIST_FOR_RENEWAL_ONLY: 3
}

export const PHARMACIST_CERTIFICATION_STRING = {
    TRAINING_CERTIFIED_PHARMACIST: '研修認定薬剤師',
    PSYCHIATRIC_SOCIETY_CERTIFIED_PHARMACIST: '精神薬学会認定薬剤師',
    CHINESE_HERBAL_MEDICINE_CRUDE_DRUG_CERTIFIED_PHARMACIST_FOR_RENEWAL_ONLY: '漢方薬・生薬認定薬剤師（更新のみ対象）',
    PEDIATRIC_DRUG_THERAPY_CERTIFIED_PHARMACIST_FOR_RENEWAL_ONLY: '小児薬物療法認定薬剤師（更新のみ対象）'
}

export const STATUS_STUDENT_GROUP = [
    {
        label: '全て',
        value: 0
    },
    {
        label: '未受講',
        value: 1
    },
    {
        label: '受講中',
        value: 2
    },
    {
        label: '受講完了',
        value: 3
    }
]

export const MESSAGE_CATEGORY = [
    {
        key: 1,
        value: '重要なお知らせ'
    },
    {
        key: 2,
        value: '受講期間終了のお知らせ'
    },
    {
        key: 7,
        value: '単位未申請のお知らせ'
    }
]

export const STUDENT_STATUS = {
    INACTIVE: 0,
    ACTIVE: 1,
    CONFIRMING: 2,
    PENDING_APPROVAL: 3
}

export const STUDENT_STATUS_STRING = {
    ACTIVE: '有効',
    INACTIVE: '無効',
    CONFIRMING: '確認中',
    PENDING_APPROVAL: '承認待ち'
}

// Numeric status → label, so screens don't repeat the same status ternary (fallback: 確認中).
export const STUDENT_STATUS_MAPPER = {
    [STUDENT_STATUS.ACTIVE]: STUDENT_STATUS_STRING.ACTIVE,
    [STUDENT_STATUS.INACTIVE]: STUDENT_STATUS_STRING.INACTIVE,
    [STUDENT_STATUS.CONFIRMING]: STUDENT_STATUS_STRING.CONFIRMING,
    [STUDENT_STATUS.PENDING_APPROVAL]: STUDENT_STATUS_STRING.PENDING_APPROVAL
}

export const COURSE_BY_STUDENT_STATUS = {
    ALL: {
        key: 0,
        label: '全て'
    },
    USER_COURSE_ATTENDING: {
        key: 1,
        label: '受講中',
        value: [0, 1, 2]
    },
    USER_COURSE_COMPLETE: {
        key: 2,
        label: '受講完了',
        value: [3]
    }
}

export const CREDIT_APPLICATION_STATUS = {
    NOT_COMPLETED: {
        value: COURSE_BY_STUDENT_STATUS.USER_COURSE_ATTENDING.value,
        label: ''
    },
    COMPLETED: {
        value: [...COURSE_BY_STUDENT_STATUS.USER_COURSE_COMPLETE.value],
        label: '単位申請済'
    },
    NO_APPLY: {
        label: '単位申請中'
    }
}

export const MESSAGE_SEND_METHOD = {
    NORMAL: {
        label: 'メッセージで送信する',
        value: 1
    },
    MAIL: {
        label: '受講者のメールアドレスへ送信する',
        value: 2
    }
}

export const SOCKET_EVENTS = {
    NEW_MESSAGE: 'NEW_MESSAGE',
    JOIN_CONVERSATION: 'JOIN_CONVERSATION',
    LEAVE_CONVERSATION: 'LEAVE_CONVERSATION',
    TRACKING_NEW_MESSAGE: 'TRACKING_NEW_MESSAGE',
    LOGIN_ANOTHER_DEVICE: 'LOGIN_ANOTHER_DEVICE',
    REGISTER_CONFIRM_EMAIL: 'REGISTER_CONFIRM_EMAIL'
}

// Above this student count, certificate PDF generation for a ticket plan switches from a
// synchronous in-request download to a background job (see #17889 1800-student scale follow-up)
// so a large company doesn't hit the proxy's request timeout while all PDFs render. Tunable per
// env/build (e.g. lower it if the backend's own concurrency was tuned down for a low-RAM server,
// see CERTIFICATE_PDF_GENERATION_CONCURRENCY server-side) — baked at build time like every other
// REACT_APP_* var in this CRA app, only read here, doesn't touch any other screen.
// eslint-disable-next-line no-undef
export const CERTIFICATE_BULK_EXPORT_THRESHOLD = process.env.REACT_APP_CERTIFICATE_BULK_EXPORT_THRESHOLD
    // eslint-disable-next-line no-undef
    ? Number(process.env.REACT_APP_CERTIFICATE_BULK_EXPORT_THRESHOLD)
    : 100;
export const CERTIFICATE_EXPORT_JOB_POLL_INTERVAL_MS = 3000;

export const DOWNLOAD_ATTENDANCE_HISTORY_TYPE = {
    ALL: 0,
    SPECIAL: 1,
    TICKET_PLAN: 2
}

export const PAYMENT_STATUS = {
    PROCESSING: 0,
    UNPAID: 1,
    PAID: 2,
    CANCEL_REQUEST: 3,
    CANCELED: 4
}

export const PAYMENT_STATUS_NAME = {
    PROCESSING: '処理中',
    UNPAID: '未払い',
    PAID: '支払済',
    CANCEL_REQUEST: 'キャンセルリクエスト中',
    CANCELED: 'キャンセル済'
}

export const COURSE_PERIOD_STATUS = {
    NOT_HAVE: 0,
    DUE: 1,
    ABOUT_TO_EXPIRE: 2,
    EXPIRED: 3
}

export const GENERAL_TYPE = {
    ABOUT_US: 'about_us',
    FAQS: 'faqs',
    USER_GUIDE: 'user_guide',
    RECOMMENDED_ENVIRONMENT: 'recommended_environment',
    TRANSACTION_LAW: 'transaction_law',
    CANCELLATION_POLICY: 'cancellation_policy',
    PRIVACY_POLICY: 'privacy_policy',
    TERM_SERVICE: 'term_service',
    ABOUT_COMPANY: 'about_company'
}

export const CREDIT_SELECT = {
    0: {
        label: '研修認定薬剤師',
        value: 0
    },
    1: {
        label: '精神薬学会認定薬剤師',
        value: 1
    },
    2: {
        label: '漢方薬・生薬認定薬剤師',
        value: 2
    },
    3: {
        label: '小児薬物療法認定薬剤師',
        value: 3
    }
}

export const CONFIRM_EMAIL_STATUS = {
    CONFIRM_EMAIL_SUCCESS: 1,
    CONFIRM_EMAIL_NOT_EXISTED_OR_EXPIRED_OR_ALREADY_CONFIRM: 2,
    CONFIRM_EMAIL_ALREADY_USE: 3
}

export const CONFIRM_EMAIL_STATUS_STRING = {
    1: 'メールアドレスが更新されました。これからは、新しいメールアドレスでログインして、システムを使用できます。',
    2: 'このリンクは有効期限が切れているか、すでに使用されています。',
    3: 'このメールアドレスはすでに別のアカウントで使用されています。新しいメールアドレスを更新してください。'
}

// type export pdf invoice
export const TYPE_EXPORT_PDF_INVOICE = {
    EXPORT_INVOICE_PDF_INDIVIDUAL: 0,
    EXPORT_INVOICE_PDF_GROUP: 1
}

// survey question type
export const SURVEY_QUESTION_TYPE = {
    TEXT: 1,
    RADIO: 2
}

// tool certificate
export const SETTING_TOOL_CERTIFICATE_TYPE = {
    NEW: 1,
    UPDATE: 2
}

export const SETTING_TOOL_CERTIFICATE_STATUS = {
    NOT_COMPLETE: 1,
    WARNING_COMPLETE: 2,
    COMPLETED: 3,
    FAILED: 4
}

export const SETTING_TOOL_CERTIFICATE_STATUS_MAPPER = {
    [SETTING_TOOL_CERTIFICATE_STATUS.NOT_COMPLETE]: {
        IMG: '/images/1-certificate-tool.svg',
        LABEL: 'C',
        TEXT_COLOR: 'red'
    },
    [SETTING_TOOL_CERTIFICATE_STATUS.WARNING_COMPLETE]: {
        IMG: '/images/2-certificate-tool.svg',
        LABEL: 'B',
        TEXT_COLOR: 'red'
    },
    [SETTING_TOOL_CERTIFICATE_STATUS.COMPLETED]: {
        IMG: '/images/3-certificate-tool.svg',
        LABEL: 'A',
        TEXT_COLOR: 'red'
    },
    [SETTING_TOOL_CERTIFICATE_STATUS.FAILED]: {
        IMG: '/images/3-certificate-tool.svg',
        LABEL: 'D',
        TEXT_COLOR: 'red'
    }
}

export const SETTING_TOOL_CERTIFICATE_TYPE_MAPPER = {
    [SETTING_TOOL_CERTIFICATE_TYPE.NEW]: {
        LABEL: '新規'
    },
    [SETTING_TOOL_CERTIFICATE_TYPE.UPDATE]: {
        LABEL: '更新'
    }
}

export const TIME_APPLY_COURSE_PERIOD = {
    IMMEDIATELY_AFTER_PURCHASE: {
        value: 1,
        label: '継続した受講期間を選択'
    },
    AFTER_THE_PREVIOUS_COURSE_PERIOD_EXPIRE: {
        value: 2,
        label: '現在の受講期間終了後から受講',
        note: '※現在の受講期間終了後に新たな受講期間が自動的に開始されます。'
    },
    SELECT_COURSE_PERIOD: {
        value: 3,
        label: '今すぐ受講'
    }
}

export const THEME_TYPE = {
    NORMAL: 1,
    STORAGE: 2,
    NON_CERTIFICATE: 3
}

export const JOIN_ATTENDANCE_CODE_STEPS = {
    VALIDATE: 1,
    CONFIRM: 2
}

export const LOGIN_TYPE = {
    STUDENT: 0,
    GROUP_ADMIN: 1
}

// #region information
export const INFORMATION_TYPE = {
    NEWS: 0,
    DRUG_INFOR: 1,
    GUIDELINE_INFOR: 2,
    OTHERS: 3
}

export const INFORMATION_TYPE_MAPPER = {
    [INFORMATION_TYPE.NEWS]: {
        LABEL: 'NEWS',
        COLORCLASS: '#26359f',
        BG_ICON: '#d9efff',
        ICON: '/images/information_news.svg'
    },
    [INFORMATION_TYPE.DRUG_INFOR]: {
        LABEL: '薬剤情報',
        COLORCLASS: '#c700a1',
        BG_ICON: '#ffe9f9',
        ICON: '/images/information_drug_info.svg'
    },
    [INFORMATION_TYPE.GUIDELINE_INFOR]: {
        LABEL: 'ガイドライン情報',
        COLORCLASS: '#2f7809',
        BG_ICON: '#dbf4d4',
        ICON: '/images/information_guideline.svg'
    },
    [INFORMATION_TYPE.OTHERS]: {
        LABEL: 'その他',
        COLORCLASS: '#d96f04',
        BG_ICON: '#ffe9d5',
        ICON: '/images/information_others.svg'
    }
}

export const READ_INFORMATION = {
    READ: 1,
    UN_READ: 2
}

export const READ_INFORMATION_MAPPER = {
    [READ_INFORMATION.READ]: {
        LABEL: '既読'
    },
    [READ_INFORMATION.UN_READ]: {
        LABEL: '未読'
    }
}

export const FILTER_INFORMATION_MAPPER = {
    NEWEST: {
        LABEL: '投稿日時が新しい順',
        SORT_KEY: '',
        SORT_DIR: ''
    },
    MOST_VIEW: {
        LABEL: '閲覧数が多い順',
        SORT_KEY: 'views',
        SORT_DIR: 'DESC'
    }
}
//#endregion

// #region level course
export const LEVEL_COURSE_TYPE = {
    NEW_COMER: 1,
    BEGIN_TO_INTERMEDIATE: 2
}

export const LEVEL_COURSE_STRING = {
    [LEVEL_COURSE_TYPE.NEW_COMER]: 'Generalist',
    [LEVEL_COURSE_TYPE.BEGIN_TO_INTERMEDIATE]: 'Specialist'
}
//#endregion

// #region filter course by publicdate V2
export const PUBLIC_DATE_FILTER_TYPE = {
    DEFAULT: 2,
    PUBLIC_DATE_DESC: 0,
    PUBLIC_DATE_ASC: 1
}

export const PUBLIC_DATE_FILTER_STRING = {
    [PUBLIC_DATE_FILTER_TYPE.DEFAULT]: '公開日順ソート',
    [PUBLIC_DATE_FILTER_TYPE.PUBLIC_DATE_DESC]: '公開日が新しい順',
    [PUBLIC_DATE_FILTER_TYPE.PUBLIC_DATE_ASC]: '公開日が古い順'
}
//#endregion

export const TRAINING_COURSE_SETTINGS_STATUS = {
    ON: 1,
    OFF: 0
}

export const TRAINING_COURSE_SETTINGS_TYPE = {
    DAY: 1,
    MONTH: 2
}

export const SCREEN_MODE = {
    ADD: 1,
    EDIT: 2,
    VIEW: 3
}

export const FILTER_STATUS_STUDENT_OF_TRAINING_COURSE = {
    NOT_ATTEND: 1,
    ATTENDING: 2,
    COMPLETED: 3
}

export const FILTER_STATUS_STUDENT_OF_TRAINING_COURSE_MAPPER = {
    [FILTER_STATUS_STUDENT_OF_TRAINING_COURSE.NOT_ATTEND]: {
        LABEL: '未受講'
    },
    [FILTER_STATUS_STUDENT_OF_TRAINING_COURSE.ATTENDING]: {
        LABEL: '受講中'
    },
    [FILTER_STATUS_STUDENT_OF_TRAINING_COURSE.COMPLETED]: {
        LABEL: '修了'
    }
}

export const FILTER_STATUS_SUBMIT_OF_TRAINING_COURSE = {
    NOT_YET_SUBMIT: 1,
    SUBMITED: 2,
    NO_NEED_SUBMIT: 3
}

export const FILTER_STATUS_SUBMIT_REPORT_OF_TRAINING_COURSE_MAPPER = {
    [FILTER_STATUS_SUBMIT_OF_TRAINING_COURSE.NOT_YET_SUBMIT]: {
        LABEL: '未提出'
    },
    [FILTER_STATUS_SUBMIT_OF_TRAINING_COURSE.SUBMITED]: {
        LABEL: '提出済'
    },
    [FILTER_STATUS_SUBMIT_OF_TRAINING_COURSE.NO_NEED_SUBMIT]: {
        LABEL: '提出物なし'
    }
}

export const FILTER_STATUS_SUBMIT_QUESTION_OF_TRAINING_COURSE_MAPPER = {
    [FILTER_STATUS_SUBMIT_OF_TRAINING_COURSE.NOT_YET_SUBMIT]: {
        LABEL: '未質問'
    },
    [FILTER_STATUS_SUBMIT_OF_TRAINING_COURSE.SUBMITED]: {
        LABEL: '質問済'
    },
    [FILTER_STATUS_SUBMIT_OF_TRAINING_COURSE.NO_NEED_SUBMIT]: {
        LABEL: '質問なし'
    }
}
// #region share knowledge
export const SHARE_KNOWLEDGE_PLAN = {
    VIDEO_ONLY_FREE: 0,
    VIDEO_ONLY_OPTION: 1,
    VIDEO_DOCUMENT_FREE: 2,
    VIDEO_DOCUMENT_OPTION: 3,
    DOCUMENT_ONLY_FREE: 4
};

export const SHARE_KNOWLEDGE_PLAN_TYPE_MAPPER = {
    ONLY_VIDEO: {
        LABEL: '動画のみ',
        VALUE: [SHARE_KNOWLEDGE_PLAN.VIDEO_ONLY_FREE, SHARE_KNOWLEDGE_PLAN.VIDEO_ONLY_OPTION]
    },
    ONLY_DOCUMENT: {
        LABEL: 'ドキュメントのみ',
        VALUE: [SHARE_KNOWLEDGE_PLAN.DOCUMENT_ONLY_FREE]
    },
    BOLT_VIDEO_AND_DOCUMENT: {
        LABEL: '動画・ドキュメント',
        VALUE: [SHARE_KNOWLEDGE_PLAN.VIDEO_DOCUMENT_FREE, SHARE_KNOWLEDGE_PLAN.VIDEO_DOCUMENT_OPTION]
    }
}

export const SHARE_KNOWLEDGE_PLAN_CATEGORY_MAPPER = {
    OPTION: {
        LABEL: 'オプションプラン',
        VALUE: [SHARE_KNOWLEDGE_PLAN.VIDEO_ONLY_OPTION, SHARE_KNOWLEDGE_PLAN.VIDEO_DOCUMENT_OPTION]
    },
    FREE: {
        LABEL: '無料プラン',
        VALUE: [SHARE_KNOWLEDGE_PLAN.DOCUMENT_ONLY_FREE, SHARE_KNOWLEDGE_PLAN.VIDEO_ONLY_FREE, SHARE_KNOWLEDGE_PLAN.VIDEO_DOCUMENT_FREE]
    }
}

export const RESIGNATION_TYPE = {
    CONTINUE: 1,
    DISCONTINUE: 2
}

export const UPDATE_NEED_CHANGE_EMAIL_STATUS = {
    APPROVED: 1,
    REJECTED: 0
}

export const SHARE_KNOWLEDGE_FILE_TYPE = {
    VIDEO: 0,
    DOCUMENT: 1
}

export const SHARE_KNOWLEDGE_FILE_TYPE_MAPPER = {
    [SHARE_KNOWLEDGE_FILE_TYPE.DOCUMENT]: {
        TEXT: 'ドキュメント',
        VALUE: SHARE_KNOWLEDGE_FILE_TYPE.DOCUMENT
    },
    [SHARE_KNOWLEDGE_FILE_TYPE.VIDEO]: {
        TEXT: '動画',
        VALUE: SHARE_KNOWLEDGE_FILE_TYPE.VIDEO
    }
}

// Per-user view status of a share knowledge video.
export const SHARE_KNOWLEDGE_VIEW_STATUS = {
    NOT_VIEWED: 0,
    VIEWING: 1,
    VIEWED: 2
}

export const SHARE_KNOWLEDGE_VIEW_STATUS_MAPPER = {
    [SHARE_KNOWLEDGE_VIEW_STATUS.NOT_VIEWED]: {
        TEXT: '未視聴',
        COLOR: '#5F5F5F',
        BG_COLOR: '#F0F0F0',
        ICON: '/images/icon-status-not-viewed.svg',
        VALUE: SHARE_KNOWLEDGE_VIEW_STATUS.NOT_VIEWED
    },
    [SHARE_KNOWLEDGE_VIEW_STATUS.VIEWING]: {
        TEXT: '視聴中',
        COLOR: '#F5A623',
        BG_COLOR: '#FDF3E2',
        ICON: '/images/icon-status-viewing.svg',
        VALUE: SHARE_KNOWLEDGE_VIEW_STATUS.VIEWING
    },
    [SHARE_KNOWLEDGE_VIEW_STATUS.VIEWED]: {
        TEXT: '視聴済',
        COLOR: '#008D45',
        BG_COLOR: '#E6F4EA',
        ICON: '/images/icon-status-viewed.svg',
        VALUE: SHARE_KNOWLEDGE_VIEW_STATUS.VIEWED
    }
}

export const EXTENSION_FILE_MAPPER = {
    WORD: {
        ICON: '/images/sk_icon_docs.png',
        VALUE: ['doc', 'docx']
    },
    EXCEL: {
        ICON: '/images/sk_icon_excel.png',
        VALUE: ['xls', 'xlsx']
    },
    CSV: {
        ICON: '/images/sk_icon_csv.png',
        VALUE: ['csv']
    },
    PDF: {
        ICON: '/images/sk_icon_pdf.png',
        VALUE: ['pdf']
    },
    POWERPOINT: {
        ICON: '/images/sk_icon_ppt.png',
        VALUE: ['ppt', 'pptx']
    },
    IMAGE: {
        VALUE: ['jpg', 'jpeg', 'png']
    }
}


export const SHARE_KNOWLEDGE_DEFAULT_CAPACITY_VALUE = {
    VIDEO_FREE: 10 * 1024 * 1024 * 1024,
    VIDEO_OPTION: 10 * 1024 * 1024 * 1024,
    DOCUMENT: 100 * 1024 * 1024
}

export const COURSE_PLAN_STATUS = {
    DOING: 1,
    COMPLETED: 2,
    DOING_AND_EXPIRED: 3
}

export const COURSE_PLAN_NOTIFY_TYPE = {
    MAIL: {
        VALUE: 1,
        LABEL: 'メールでリマインド'
    },
    MAIL_AND_MESSAGE: {
        VALUE: 2,
        LABEL: 'メールと通知でリマインド'
    },
    MESSAGE: {
        VALUE: 3,
        LABEL: '通知でリマインド'
    }
}

export const COURSE_PLAN_REMIND_TYPE = {
    BEFORE_EXPIRED: 1,
    ON_EXPIRED_DAY: 2
}

export const COURSE_PLAN_REMIND_TYPE_MAPPER = {
    [COURSE_PLAN_REMIND_TYPE.BEFORE_EXPIRED]: '期限日前',
    [COURSE_PLAN_REMIND_TYPE.ON_EXPIRED_DAY]: '期限日当日'
}

export const TOP_PAGE_THEME_TYPE = {
    DEFAULT: 'TOP_PAGE_THEME',
    PREVIEW: 'TOP_PAGE_THEME_DRAFT'
}

export const ROLE = {
    ROLE_INDIVIDUAL: 3,
    ROLE_STUDENT: 4,
    STD_WAIT_SELECT: 5
}

export const SHOW_ATTENDANCE_HISTORY_EI = false;
